<template>
  <FormComponent
    :models="formModels"
    :loading="loading"
    type="trainingCourse_duplication"
    @formSubmit="submit"
    @formCancel="cancel"
  >
    <template #formView="{ ajaxTargetLoad, ajaxTargetTrig, draft }" v-if="formModels">
      <div class="row">
        <div class="form-column col-md-6 col-12" v-if="formModels.referenceColumn">
          <div class="form-title mb-3">
            <h2>{{ $t("studea_manager.duplicated.reference") }}</h2>
          </div>
          <span>{{ $t("studea_manager.duplicated.training_course.duplicate_choice") }}</span>
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.from" @draft="draft" />
          <p
            v-if="Number(formModels.referenceColumn.children?.from.vars.value) === duplicateFromReference"
            v-html="$t('studea_manager.duplicated.training_course.duplicate_from_reference')"
          ></p>
          <p
            v-if="Number(formModels.referenceColumn.children?.from.vars.value) === duplicateOneYearToOther"
            v-html="$t('studea_manager.duplicated.training_course.duplicate_from_year')"
          ></p>
          <FormFieldComponent
            :model="formModels.referenceColumn.children?.referenceYear"
            v-if="
              formModels.referenceColumn &&
              formModels.referenceColumn.children?.referenceYear &&
              formModels?.referenceColumn?.children?.from?.vars?.value === '2'
            "
          />
          <template v-if="formModels?.referenceColumn?.children?.from?.vars?.value === '1'">
            <FormFieldComponent
              :model="formModels.referenceColumn?.children.institution"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
            />
            <FormFieldComponent
              :model="formModels.referenceColumn?.children.component"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
            />
            <FormFieldComponent
              :model="formModels.referenceColumn?.children.training"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
            />
            <FormFieldComponent
              :model="formModels.referenceColumn?.children.trainingCourse"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
            />
          </template>
        </div>
        <div
          class="form-column last col-md-6 col-12"
          v-if="
            formModels.destinationColumn &&
            formModels.destinationColumn.children?.trainingCourseDestination &&
            formModels?.referenceColumn?.children?.from?.vars?.value === '1'
          "
        >
          <div class="form-title mb-3">
            <h2>{{ $t("studea_manager.duplicated.destination") }}</h2>
          </div>
          <FormFieldComponent :model="formModels.destinationColumn.children?.trainingCourseDestination" />
        </div>
      </div>
      <div class="row">
        <div class="form-title mb-3">
          <h2>
            {{ $t("studea_manager.duplicated.training_course.duplicated_data") }}
          </h2>
        </div>
        <div class="mb-4 text-center">
          {{ $t("studea_manager.duplicated.training_course.add_data_if_empty") }}
        </div>
      </div>
      <div class="duplication__choices" v-if="formModels.referenceColumn">
        <div>
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.questionnaire" />
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.skills" />
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.subject" />
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.lesson" />
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.webLinks" />
          <FormFieldComponent :model="formModels?.referenceColumn?.children?.studeaManagers" />
        </div>
      </div>
    </template>
  </FormComponent>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import FormFieldComponent from "@/components/form/FormFieldComponent.vue";

export default {
  name: "TrainingCourseDuplicationComponent",
  data() {
    return {
      formModels: this.models,
      duplicateFromReference: 1,
      duplicateOneYearToOther: 2,
    };
  },
  props: {
    models: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { FormFieldComponent, FormComponent },
  emits: ["submit", "cancel"],
  methods: {
    submit(payload) {
      this.$emit("submit", payload);
    },

    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.form-column {
  @include up-to-md {
    border: none;
  }
  height: inherit;

  &.first {
    @include up-to-md {
      padding-right: inherit;
    }
  }

  &.mid {
    padding-left: calc(var(--bs-gutter-x) * 0.5);
    padding-right: inherit;
  }

  &.last {
    padding-right: inherit;
  }
}

.duplication__legend {
  font-weight: 400;
  margin-top: -15px;
}

.duplication__choices {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    width: 300px;
  }
}
</style>
